import { gql } from '@apollo/client'

import { SHOP_STRIPE_ACCOUNT_FRAGMENT } from './shop/stripeAccount'

export const ACCOUNT_FRAGMENT = gql`
  fragment Account on Account {
    customerAccountsState
    id
    ownerStripeAccount {
      ...ShopStripeAccount
    }
  }

  ${SHOP_STRIPE_ACCOUNT_FRAGMENT}
`
